<template>
  <v-container fluid>
    <v-layout row>
      <v-flex
        shrink
        hidden-xs-and-down
      >
        <v-avatar
          size="35"
          class="ml-2"
        >
          <img
            :src="userAvatar || message.iconUrl"
            alt="avatar"
          >
        </v-avatar>
      </v-flex>
      <v-flex shrink> 
        <v-card
          class="pa-2 pl-3 pr-3 message-card"
          :color="isMyMessage ? 'white' : 'white' "
          flat
        >
          <h4>
            {{ messageUser ? messageUser.name : message.username }}
            <span v-if="messageAranName" class="grey--text font-weight-regular pl-1 pr-1">({{ messageAranName }})</span>
            <span class="grey--text font-weight-regular pl-1 pr-1">{{ time }}</span>
            <!-- <v-progress-circular
              v-if="message.sending"
              indeterminate
              size="16"
              width="1"
              color="grey"
            /> -->
            <!-- <span
              class="grey--text font-weight-regular"
              v-if="isMyMessage && !message.sending && !message.sendError"
            >
              <v-icon size="medium">check</v-icon>
            </span>
            <span
              class="red--text font-weight-bold"
              v-if="message.sendError"
            >
              <v-icon
                size="medium"
                color="red"
              >error</v-icon> ההודעה לא נשלחה <v-btn
                small
                color="error"
                icon
                :loading="message.sending"
              >
                <v-icon>send</v-icon>
              </v-btn>
            </span> -->
          </h4>
          <div
            v-html="message.text"
            class="subheading"
          ></div>
          <template
            v-for="block in message.blocks"
            class="block"
          >
            <block :block="block" />
          </template>
          <div class="pt-2" v-if="(message.tags && message.tags.length)">
            <span
              v-for="tag in (message.tags || [])"
              :key="tag"
              class="hashtag ml-1"
            >
              #{{ tag }}
            </span>
            <!-- <v-chip
              small
              label
              color="primary"
              text-color="white"
              disabled
            >
              <v-icon left>mdi-pound</v-icon> יומן אירועים
            </v-chip> -->
          </div>
          <v-menu
            bottom
            right
          >
            <template v-slot:activator="{ on }">
              <v-btn
                small
                icon
                flat
                v-on="on"
                class="message-menu"
              >
                <v-icon small>more_vert</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-tile
                v-for="(item, i) in menuItems"
                :key="i"
                @click="envokeMethodByName(item.click)"
              >
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { format } from "date-fns";
import colors from "vuetify/es5/util/colors";
import Block from "./Block.vue";
import { camelCase } from "lodash";

export default {
  data() {
    return {
      menuItems: [
        {
          title: "עריכת תאגים",
          click: "editMessageTags"
        }
      ]
    };
  },

  computed: {
    isMyMessage() {
      let userId = this.message.user ? this.message.user._id || this.message.user : null;
      return this.user._id === userId;
    },
    messageUser() {
      if (this.message.user) {
        return this.$store.state.entities.users[this.message.user];
      }
    },
    userAvatar() {
      if (this.messageUser) {
        if (this.messageUser.image) {
          return this.messageUser.image;
        } else {
          return `https://ui-avatars.com/api/?name=${
            this.userAvatarName
          }&background=${
            this.userAvatarColor
          }&size=80&color=ffffff&rounded=1&length=1`;
        }
      }
    },
    userAvatarName() {
      return this.messageUser ? this.messageUser.name : null;
    },
    userAvatarColor() {
      if (this.messageUser) {
        let color = this.messageUser.color;
        if (color) {
          color = camelCase(color);
        } else {
          color = "blue";
        }
        return colors[color].base.substr(1);
      } else {
        return null;
      }
    },
    user() {
      return this.$store.getters["user/user"];
    },
    time() {
      if (this.message.ts) {
        return this.tsToString(this.message.ts);
      } else {
        return format(new Date(this.message.created), "DD/MM/YY HH:mm");
      }
    },
    messageAranName() {
      // Only show event name in כולם mode (when showing multiple events)
      const eventIdsToShow = this.$store.getters["events/eventIdsToShow"];
      if (eventIdsToShow && eventIdsToShow.length > 1) {
        // Get the chat for this message
        const chat = Object.values(this.$store.state.entities.chats).find(c => c._id === this.message.chat);
        if (chat) {
          // Get the event for this chat
          const event = this.$store.state.entities.events[chat.event];
          if (event) {
            // Return the event title/name
            return event.title || event.name || `אירוע ${event._id}`;
          }
        }
      }
      return null;
    },
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    }
  },

  methods: {
    envokeMethodByName(name) {
      this[name]();
    },
    tsToString(ts) {
      if (!ts) {
        return "";
      }
      let parsedTs = ts.split(".")[0];
      let unixTs = parseInt(ts);
      if (unixTs) {
        let date = new Date(unixTs * 1000);
        return format(date, "DD/MM/YY HH:mm");
      }
    },
    editMessageTags() {
      let entity = this.message;
      let isNew = false;

      // Set default tag if no tags exist
      if (!entity.tags || entity.tags.length === 0) {
        entity.tags = ['יומן_אירועים'];
      }

      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: "chatMessageSchema"
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource: this.$store.state.resources.chatMessageTags,
        isNew
      });
      this.entityEditDialog = true;
    }
  },

  components: {
    Block
  },

  props: ["message"]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.message-card {
  border-radius: 15px;

  h4 {
    margin-left: 50px;
  }
}

p {
  margin-bottom: 0px !important;
}
</style>

<style lang="scss">
.message-menu {
  position: absolute !important;
  top: 0;
  left: 0;
}

.message-card {
  p {
    margin-bottom: 0px !important;
    word-break: break-word;
  }
}

// .hashtag {
//   background-color: rgba(0, 0, 0, 0.5)
// }
</style>


// WEBPACK FOOTER //
// src/components/chat/Message.vue